"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebViewContext = exports.WebViewContext_ExbInAppHtmlResolveStatus = void 0;
const long_1 = __importDefault(require("long"));
const webview_load_info_1 = require("./webview_load_info");
const webview_autofill_info_1 = require("./webview_autofill_info");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
/** exb in app html resolve status */
var WebViewContext_ExbInAppHtmlResolveStatus;
(function (WebViewContext_ExbInAppHtmlResolveStatus) {
    /** UNSET - enum unset */
    WebViewContext_ExbInAppHtmlResolveStatus[WebViewContext_ExbInAppHtmlResolveStatus["UNSET"] = 0] = "UNSET";
    /** SUCCESS - exb in app html resolve success, exb opened */
    WebViewContext_ExbInAppHtmlResolveStatus[WebViewContext_ExbInAppHtmlResolveStatus["SUCCESS"] = 1] = "SUCCESS";
    /** HTML_RESOLVING - exb in app html resolve still pending html resolve */
    WebViewContext_ExbInAppHtmlResolveStatus[WebViewContext_ExbInAppHtmlResolveStatus["HTML_RESOLVING"] = 2] = "HTML_RESOLVING";
    /** HTML_RESOLVE_ERROR - exb in app html resolve error */
    WebViewContext_ExbInAppHtmlResolveStatus[WebViewContext_ExbInAppHtmlResolveStatus["HTML_RESOLVE_ERROR"] = 3] = "HTML_RESOLVE_ERROR";
    /** REDIRECT_HINTS_MISMATCH - exb in app html resolve encounter mismatch redirect hints */
    WebViewContext_ExbInAppHtmlResolveStatus[WebViewContext_ExbInAppHtmlResolveStatus["REDIRECT_HINTS_MISMATCH"] = 4] = "REDIRECT_HINTS_MISMATCH";
    WebViewContext_ExbInAppHtmlResolveStatus[WebViewContext_ExbInAppHtmlResolveStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(WebViewContext_ExbInAppHtmlResolveStatus = exports.WebViewContext_ExbInAppHtmlResolveStatus || (exports.WebViewContext_ExbInAppHtmlResolveStatus = {}));
function createBaseWebViewContext() {
    return {
        pageViewGaHit: false,
        gaHitCounts: false,
        domDownloadLatencyMillis: "0",
        domLoadLatencyMillis: "0",
        hasSubsequentNavigation: false,
        prefetched: false,
        gaHitTypes: [],
        loadProgress: undefined,
        firstContentfulPaintLatency: "0",
        webViewLoadInfo: undefined,
        gaIncluded: undefined,
        firstGaTriggerLatency: undefined,
        resourcesPrefetchCount: 0,
        prefetchMode: 0,
        openInBrowser: false,
        landingPageGaPageViewHit: false,
        firstPixelTriggerLatency: undefined,
        webBrowserType: 0,
        hasJsBasedPerformanceTiming: false,
        webViewAutofillInfo: undefined,
        firstGaHitTsMs: undefined,
        firstAdobePingTsMs: undefined,
        adobePingCount: undefined,
        htmlPrefetchStartTsMs: undefined,
        htmlPrefetchEndTsMs: undefined,
        loadPrefetchedHtml: false,
        rawPerformanceMetrics: "",
        perfMetricsLoadError: false,
        perfMetricLoadErrorReason: "",
        lightningModeEnableServerSetting: undefined,
        lightningModeUrl: undefined,
        scCidDropDetected: undefined,
        exbInAppHtmlResolveStatus: 0,
        exbOpenedOnSubNav: false,
        deeplinkAttempted: false,
        detectSnapPixelEvent: false,
        snapPixelHasCid: false,
    };
}
exports.WebViewContext = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pageViewGaHit === true) {
            writer.uint32(8).bool(message.pageViewGaHit);
        }
        if (message.gaHitCounts === true) {
            writer.uint32(16).bool(message.gaHitCounts);
        }
        if (message.domDownloadLatencyMillis !== "0") {
            writer.uint32(24).int64(message.domDownloadLatencyMillis);
        }
        if (message.domLoadLatencyMillis !== "0") {
            writer.uint32(32).int64(message.domLoadLatencyMillis);
        }
        if (message.hasSubsequentNavigation === true) {
            writer.uint32(40).bool(message.hasSubsequentNavigation);
        }
        if (message.prefetched === true) {
            writer.uint32(48).bool(message.prefetched);
        }
        for (const v of message.gaHitTypes) {
            wrappers_1.StringValue.encode({ value: v }, writer.uint32(58).fork()).ldelim();
        }
        if (message.loadProgress !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.loadProgress }, writer.uint32(66).fork()).ldelim();
        }
        if (message.firstContentfulPaintLatency !== "0") {
            writer.uint32(72).int64(message.firstContentfulPaintLatency);
        }
        if (message.webViewLoadInfo !== undefined) {
            webview_load_info_1.WebViewLoadInfo.encode(message.webViewLoadInfo, writer.uint32(82).fork()).ldelim();
        }
        if (message.gaIncluded !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.gaIncluded }, writer.uint32(90).fork()).ldelim();
        }
        if (message.firstGaTriggerLatency !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.firstGaTriggerLatency }, writer.uint32(98).fork()).ldelim();
        }
        if (message.resourcesPrefetchCount !== 0) {
            writer.uint32(104).int32(message.resourcesPrefetchCount);
        }
        if (message.prefetchMode !== 0) {
            writer.uint32(112).int32(message.prefetchMode);
        }
        if (message.openInBrowser === true) {
            writer.uint32(120).bool(message.openInBrowser);
        }
        if (message.landingPageGaPageViewHit === true) {
            writer.uint32(128).bool(message.landingPageGaPageViewHit);
        }
        if (message.firstPixelTriggerLatency !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.firstPixelTriggerLatency }, writer.uint32(138).fork()).ldelim();
        }
        if (message.webBrowserType !== 0) {
            writer.uint32(144).int32(message.webBrowserType);
        }
        if (message.hasJsBasedPerformanceTiming === true) {
            writer.uint32(152).bool(message.hasJsBasedPerformanceTiming);
        }
        if (message.webViewAutofillInfo !== undefined) {
            webview_autofill_info_1.WebViewAutofillInfo.encode(message.webViewAutofillInfo, writer.uint32(162).fork()).ldelim();
        }
        if (message.firstGaHitTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.firstGaHitTsMs }, writer.uint32(170).fork()).ldelim();
        }
        if (message.firstAdobePingTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.firstAdobePingTsMs }, writer.uint32(178).fork()).ldelim();
        }
        if (message.adobePingCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.adobePingCount }, writer.uint32(186).fork()).ldelim();
        }
        if (message.htmlPrefetchStartTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.htmlPrefetchStartTsMs }, writer.uint32(194).fork()).ldelim();
        }
        if (message.htmlPrefetchEndTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.htmlPrefetchEndTsMs }, writer.uint32(202).fork()).ldelim();
        }
        if (message.loadPrefetchedHtml === true) {
            writer.uint32(208).bool(message.loadPrefetchedHtml);
        }
        if (message.rawPerformanceMetrics !== "") {
            writer.uint32(218).string(message.rawPerformanceMetrics);
        }
        if (message.perfMetricsLoadError === true) {
            writer.uint32(224).bool(message.perfMetricsLoadError);
        }
        if (message.perfMetricLoadErrorReason !== "") {
            writer.uint32(234).string(message.perfMetricLoadErrorReason);
        }
        if (message.lightningModeEnableServerSetting !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.lightningModeEnableServerSetting }, writer.uint32(242).fork()).ldelim();
        }
        if (message.lightningModeUrl !== undefined) {
            wrappers_1.StringValue.encode({ value: message.lightningModeUrl }, writer.uint32(250).fork()).ldelim();
        }
        if (message.scCidDropDetected !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.scCidDropDetected }, writer.uint32(258).fork()).ldelim();
        }
        if (message.exbInAppHtmlResolveStatus !== 0) {
            writer.uint32(264).int32(message.exbInAppHtmlResolveStatus);
        }
        if (message.exbOpenedOnSubNav === true) {
            writer.uint32(272).bool(message.exbOpenedOnSubNav);
        }
        if (message.deeplinkAttempted === true) {
            writer.uint32(280).bool(message.deeplinkAttempted);
        }
        if (message.detectSnapPixelEvent === true) {
            writer.uint32(288).bool(message.detectSnapPixelEvent);
        }
        if (message.snapPixelHasCid === true) {
            writer.uint32(296).bool(message.snapPixelHasCid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewContext();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pageViewGaHit = reader.bool();
                    break;
                case 2:
                    message.gaHitCounts = reader.bool();
                    break;
                case 3:
                    message.domDownloadLatencyMillis = longToString(reader.int64());
                    break;
                case 4:
                    message.domLoadLatencyMillis = longToString(reader.int64());
                    break;
                case 5:
                    message.hasSubsequentNavigation = reader.bool();
                    break;
                case 6:
                    message.prefetched = reader.bool();
                    break;
                case 7:
                    message.gaHitTypes.push(wrappers_1.StringValue.decode(reader, reader.uint32()).value);
                    break;
                case 8:
                    message.loadProgress = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.firstContentfulPaintLatency = longToString(reader.int64());
                    break;
                case 10:
                    message.webViewLoadInfo = webview_load_info_1.WebViewLoadInfo.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.gaIncluded = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 12:
                    message.firstGaTriggerLatency = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 13:
                    message.resourcesPrefetchCount = reader.int32();
                    break;
                case 14:
                    message.prefetchMode = reader.int32();
                    break;
                case 15:
                    message.openInBrowser = reader.bool();
                    break;
                case 16:
                    message.landingPageGaPageViewHit = reader.bool();
                    break;
                case 17:
                    message.firstPixelTriggerLatency = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 18:
                    message.webBrowserType = reader.int32();
                    break;
                case 19:
                    message.hasJsBasedPerformanceTiming = reader.bool();
                    break;
                case 20:
                    message.webViewAutofillInfo = webview_autofill_info_1.WebViewAutofillInfo.decode(reader, reader.uint32());
                    break;
                case 21:
                    message.firstGaHitTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 22:
                    message.firstAdobePingTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 23:
                    message.adobePingCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 24:
                    message.htmlPrefetchStartTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 25:
                    message.htmlPrefetchEndTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 26:
                    message.loadPrefetchedHtml = reader.bool();
                    break;
                case 27:
                    message.rawPerformanceMetrics = reader.string();
                    break;
                case 28:
                    message.perfMetricsLoadError = reader.bool();
                    break;
                case 29:
                    message.perfMetricLoadErrorReason = reader.string();
                    break;
                case 30:
                    message.lightningModeEnableServerSetting = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 31:
                    message.lightningModeUrl = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 32:
                    message.scCidDropDetected = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 33:
                    message.exbInAppHtmlResolveStatus = reader.int32();
                    break;
                case 34:
                    message.exbOpenedOnSubNav = reader.bool();
                    break;
                case 35:
                    message.deeplinkAttempted = reader.bool();
                    break;
                case 36:
                    message.detectSnapPixelEvent = reader.bool();
                    break;
                case 37:
                    message.snapPixelHasCid = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseWebViewContext();
        message.pageViewGaHit = object.pageViewGaHit ?? false;
        message.gaHitCounts = object.gaHitCounts ?? false;
        message.domDownloadLatencyMillis = object.domDownloadLatencyMillis ?? "0";
        message.domLoadLatencyMillis = object.domLoadLatencyMillis ?? "0";
        message.hasSubsequentNavigation = object.hasSubsequentNavigation ?? false;
        message.prefetched = object.prefetched ?? false;
        message.gaHitTypes = object.gaHitTypes?.map((e) => e) || [];
        message.loadProgress = object.loadProgress ?? undefined;
        message.firstContentfulPaintLatency =
            object.firstContentfulPaintLatency ?? "0";
        message.webViewLoadInfo =
            object.webViewLoadInfo !== undefined && object.webViewLoadInfo !== null
                ? webview_load_info_1.WebViewLoadInfo.fromPartial(object.webViewLoadInfo)
                : undefined;
        message.gaIncluded = object.gaIncluded ?? undefined;
        message.firstGaTriggerLatency = object.firstGaTriggerLatency ?? undefined;
        message.resourcesPrefetchCount = object.resourcesPrefetchCount ?? 0;
        message.prefetchMode = object.prefetchMode ?? 0;
        message.openInBrowser = object.openInBrowser ?? false;
        message.landingPageGaPageViewHit = object.landingPageGaPageViewHit ?? false;
        message.firstPixelTriggerLatency =
            object.firstPixelTriggerLatency ?? undefined;
        message.webBrowserType = object.webBrowserType ?? 0;
        message.hasJsBasedPerformanceTiming =
            object.hasJsBasedPerformanceTiming ?? false;
        message.webViewAutofillInfo =
            object.webViewAutofillInfo !== undefined &&
                object.webViewAutofillInfo !== null
                ? webview_autofill_info_1.WebViewAutofillInfo.fromPartial(object.webViewAutofillInfo)
                : undefined;
        message.firstGaHitTsMs = object.firstGaHitTsMs ?? undefined;
        message.firstAdobePingTsMs = object.firstAdobePingTsMs ?? undefined;
        message.adobePingCount = object.adobePingCount ?? undefined;
        message.htmlPrefetchStartTsMs = object.htmlPrefetchStartTsMs ?? undefined;
        message.htmlPrefetchEndTsMs = object.htmlPrefetchEndTsMs ?? undefined;
        message.loadPrefetchedHtml = object.loadPrefetchedHtml ?? false;
        message.rawPerformanceMetrics = object.rawPerformanceMetrics ?? "";
        message.perfMetricsLoadError = object.perfMetricsLoadError ?? false;
        message.perfMetricLoadErrorReason = object.perfMetricLoadErrorReason ?? "";
        message.lightningModeEnableServerSetting =
            object.lightningModeEnableServerSetting ?? undefined;
        message.lightningModeUrl = object.lightningModeUrl ?? undefined;
        message.scCidDropDetected = object.scCidDropDetected ?? undefined;
        message.exbInAppHtmlResolveStatus = object.exbInAppHtmlResolveStatus ?? 0;
        message.exbOpenedOnSubNav = object.exbOpenedOnSubNav ?? false;
        message.deeplinkAttempted = object.deeplinkAttempted ?? false;
        message.detectSnapPixelEvent = object.detectSnapPixelEvent ?? false;
        message.snapPixelHasCid = object.snapPixelHasCid ?? false;
        return message;
    },
};
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=webview_context.js.map